import t from './story05.translations'

export default {
  title: t.title,
  excerpt: t.excerpt,

  prose: [
    // Run 1 — the open, seven paragraphs, up to the first photograph.
    [
      { text: t.s1P1 },
      { text: t.s1P2 },
      { text: t.s1P3 },
      { text: t.s1P4 },
      { text: t.s1P5 },
      { text: t.s1P6 },
      { text: t.s1P7 },
    ],
    // Run 2 — under image 1, the abandoned pit. The only one that runs to two
    // paragraphs.
    [{ text: t.s2P1 }, { text: t.s2P2 }],
    // Run 3 — under image 2, the men wading the slurry.
    [{ text: t.s3P1 }],
    // Run 4 — under image 3, Alfonso the trader.
    [{ text: t.s4P1 }],
    // Run 5 — under image 4, Ikrane, 13.
    [{ text: t.s5P1 }],
    // Run 6 — under image 5, the close: Bangka as Mars.
    [{ text: t.s6P1 }],
  ],

  // No per-figure captions: the prose runs above are what sits under each photo, and
  // the whole set shares one credit.
  credit: t.credit,
} as const
